import { render, staticRenderFns } from "./ModalRecordEdit.vue?vue&type=template&id=ad788284"
import script from "./ModalRecordEdit.vue?vue&type=script&lang=js"
export * from "./ModalRecordEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports